import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { BASE_URL } from "./Constants.js";
import MD5 from "crypto-js/md5";

const siteKey = '6LfUXGorAAAAAJBb_plC7KxLv_wZ63e7vcqeklDt'; // Replace with your site key

const Login = () => {
  const [userId, setUserId] = useState('');
  const [userPwd, setUserPwd] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
   const [autoLoginReady, setAutoLoginReady] = useState(false);
  const navigate = useNavigate();

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const fetchUserProfile = async (token) => {
    try {
      const response = await fetch(`${BASE_URL}/profile`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const profileResult = await response.json();
      const hashedPassword = MD5('adnet2008').toString();

      if (hashedPassword === profileResult.profile.password) {
        navigate('/change_password');
        return;
      }
 sessionStorage.setItem("userEmpCode",profileResult.profile.emp_code)
      sessionStorage.setItem("userProfile", JSON.stringify(profileResult.profile));
      localStorage.setItem("authToken", token);
      localStorage.setItem("exp", Date.now() + 3595000);
      navigate("/dashboard");

    } catch (err) {
      console.error("Profile fetch error:", err);
      setError("Failed to fetch user profile.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');


    setLoading(true);
    const formData = new FormData();
    formData.append('USER_ID', userId);
    formData.append('USER_PWD', userPwd);

    try {
      const response = await fetch(`${BASE_URL}login1`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.status) {
        await fetchUserProfile(data.token);
      } else {
        setError(data.message || 'Invalid credentials.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const uid = queryParams.get('uid');
      const pwd = queryParams.get('pwd');
  
      if (uid && pwd) {
        const decodedUid = atob(uid);
        const decodedPwd = (pwd);
  
        setUserId(decodedUid);
        setUserPwd(decodedPwd);
  
        setAutoLoginReady(true); // Show the form
        setTimeout(() => {
          document.getElementById('autoLoginBtn')?.click();
        }, 200); // Delay to allow form to render
      } else {
        setAutoLoginReady(true); // Show form even if no auto-login
      }
    }, []);

  return (
    <div className="page-wrapper" style={{
  display: 'flex',
  flexDirection: 'row',
  minHeight: '100vh',
  position: 'relative',
  paddingBottom: '80px', // reserve space for footer
  fontFamily: 'Segoe UI, sans-serif'
}}>
      {/* Left Side: Image */}
      <div
  style={{
    flex: 1,
    background: 'url("/images/uniform.png") no-repeat center center',
    backgroundSize: 'cover',
    borderRight: '5px solid #e0e0e0',
    margin: '12px',
    borderRadius: '20px',
    boxShadow: 'rgba(0, 0, 0, 0.1) 20px 20px 20px'
  }}
/>

      {/* Right Side: Login Form */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f9f9f9'
      }}>
        <div style={{
          width: '100%',
          maxWidth: '400px',
          background: '#fff',
          padding: '40px',
          borderRadius: '10px',
          boxShadow: '0 0 20px rgba(0,0,0,0.1)'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <img src="/images/logo.jpg" alt="VDC" style={{ height: 60 }} />
            <h2 style={{ marginTop: '10px', color: '#333' }}>Work Attire</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '15px' }}>
              <label>User ID</label>
              <input
                type="text"
                value={userId}
                name="USER_ID"
                onChange={(e) => setUserId(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc'
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label>Password</label>
              <input
                type="password"
                value={userPwd}
                 name="USER_PWD"
                onChange={(e) => setUserPwd(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc'
                }}
              />
            </div>
            {/* <div style={{ marginBottom: '15px' }}>
              <ReCAPTCHA sitekey={siteKey} onChange={handleCaptchaChange} />
            </div> */}
            {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                backgroundColor: '#28a745',
                color: '#fff',
                padding: '12px',
                border: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
              id="autoLoginBtn"
            >
              {loading ? 'Signing In...' : 'Log In'}
            </button>
            <div style={{ textAlign: 'center', marginTop: '15px', fontSize: '12px', color: '#999' }}>
              Version 1.0
            </div>
          </form>
        </div>
      </div>
      <footer
  style={{
    width: "100%",
    backgroundColor: "#f8f9fa",
    textAlign: "center",
    padding: "16px 0",
    borderTop: "1px solid #dee2e6",
    fontSize: "14px",
    color: "#6c757d",
    position: "absolute",
    bottom: 0,
    left: 0,
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "12px",
      marginBottom: "8px",
    }}
  >
    <Link to="/about" style={{ color: "#6c757d", textDecoration: "none" }}>About Us</Link>
    <span>|</span>
    <Link to="/privacy" style={{ color: "#6c757d", textDecoration: "none" }}>Privacy Policy</Link>
    <span>|</span>
    <Link to="/terms" style={{ color: "#6c757d", textDecoration: "none" }}>Terms & Conditions</Link>
    <span>|</span>
    <Link to="/contact" style={{ color: "#6c757d", textDecoration: "none" }}>Contact Us</Link>
  </div>
  <div>
    <small>© {new Date().getFullYear()} Vijaya Diagnostic Centre. All rights reserved.</small>
  </div>
</footer>

    </div>
  );
};

export default Login;
